/**
 * Canonical PostHog event names for Write4Me.
 *
 * All `captureEvent` / `posthog.capture` calls in the codebase MUST use a
 * constant from this file so PostHog dashboards see a stable, snake_case
 * taxonomy. Adding a new tracked event = add a constant here first, then
 * wire it at the call site.
 */
export const PH = {
  // Landing page (marketing site, root path `/`)
  LANDING_VIEWED: 'landing_viewed',
  LANDING_SECTION_VIEWED: 'landing_section_viewed',
  LANDING_CTA_CLICKED: 'landing_cta_clicked',

  // Auth
  SIGNED_UP: 'user_signed_up',
  SIGNED_IN: 'user_signed_in',

  // Onboarding / activation
  ROLE_SELECTED: 'role_selected',
  ONBOARDING_COMPLETED: 'onboarding_completed',
  // Dedicated in-onboarding trial-activation step (employer). VIEWED fires when
  // the step renders for an eligible employer; STARTED when they open the
  // embedded checkout. The webhook-sourced SUBSCRIPTION_TRIAL_STARTED remains
  // the conversion source of truth — there is no _SKIPPED event (the step has
  // no skip; abandonment is inferred from VIEWED-without-STARTED).
  ONBOARDING_TRIAL_VIEWED: 'onboarding_trial_viewed',
  ONBOARDING_TRIAL_STARTED: 'onboarding_trial_started',

  // Workspace lifecycle
  WORKSPACE_CREATED: 'workspace_created',
  WORKSPACE_DELETED: 'workspace_deleted',
  WORKSPACE_INVITATION_SENT: 'workspace_invitation_sent',

  // Tasks
  TASK_CREATED: 'task_created',
  TASK_TEMPLATE_CREATED: 'task_template_created',
  MATCH_WRITER_USED: 'match_writer_used',
  TASK_ASSIGNED: 'task_assigned',
  TASK_INVITE_ACCEPTED: 'task_invite_accepted',
  TASK_INVITE_DECLINED: 'task_invite_declined',
  TASK_SUBMITTED: 'task_submitted',
  TASK_REVISION_REQUESTED: 'task_revision_requested',
  TASK_APPROVED: 'task_approved',

  // Wallet / payments
  WALLET_TOPUP_INITIATED: 'wallet_topup_initiated',
  WALLET_TOPUP_COMPLETED: 'wallet_topup_completed',
  WALLET_WITHDRAWAL: 'wallet_withdrawal',
  SUBSCRIPTION_CHECKOUT_STARTED: 'subscription_checkout_started',
  SUBSCRIPTION_PAID: 'subscription_paid',
  SUBSCRIPTION_TRIAL_STARTED: 'subscription_trial_started',
  SUBSCRIPTION_CANCELLED: 'subscription_cancelled',
  SUBSCRIPTION_PAUSED: 'subscription_paused',
  SUBSCRIPTION_RESUMED: 'subscription_resumed',
  BILLING_PORTAL_OPENED: 'billing_portal_opened',

  // Verification & account
  KYC_STARTED: 'kyc_started',
  KYC_VERIFIED: 'kyc_verified',
  ACCOUNT_DELETED: 'account_deleted',
} as const;

export type PostHogEvent = (typeof PH)[keyof typeof PH];
